<template>
  <div class="overviewapplisting-container">
     <div v-if="userinfo.tenantType ===0 || userinfo.tenantType ===1">
      <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('operate.name1')" prop="tenantId">
            <el-cascader v-model="tenantIds" ref="refHandle" :placeholder="$t('public.name1')" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('operate.name127')" prop="appCode">
            <el-input v-model="queryInfo.appCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('operate.name128')" prop="appName">
            <el-input v-model="queryInfo.appName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')"><el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          </el-form-item>
          <el-form-item >
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
      </el-form>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="handleAdd(false)" v-if="buttonPerms.indexOf('sysapp/saveApp/cstomized') > -1">{{ $t('operate.name140') }}</el-button>
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="handleAdd(true)" v-if="buttonPerms.indexOf('sysapp/saveApp/general') > -1">{{ $t('operate.name141') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name3')" prop="appCode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name4')" prop="tenantName" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.tenantName">{{ scope.row.parentTenantName }} > {{ scope.row.tenantName }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name5')" prop="appName" sortable></el-table-column>
      <el-table-column :label="$t('operate.name6')" prop="appIcon" sortable>
        <template slot-scope="scope">
         <img :src="scope.row.appIcon" style="width:50px; height:50px;"/>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name7')" prop="laber" sortable></el-table-column>
       <el-table-column :label="$t('operate.name179')" prop="appDownloadUrl" sortable>
        <template slot-scope="scope">
        <div v-if="scope.row.appDownloadUrl">
            {{ baseUrl + scope.row.appDownloadUrl }}
        </div>
        </template>
       </el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <el-switch :value="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name8')" prop="newCreateTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.newCreateTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name9')" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)"  v-if="buttonPerms.indexOf('overviewapplisting/edit') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="showMerchantDialog(scope.row)" v-if="scope.row.general && buttonPerms.indexOf('overviewapplisting/merchantList') > -1">{{ $t('operate.name129') }}</el-button>
          <el-button type="text" @click="showVersionDialog(scope.row)">{{ $t('operate.name10') }}</el-button>
          <el-button type="text" @click="showAppConfigurationDialog(scope.row)">{{ $t('tabmenu.name60') }}</el-button>
          <el-button type="text" @click="showAddDialog(scope.row,1)" v-if="buttonPerms.indexOf('overviewapplisting/add') > -1">{{ $t('operate.name130') }}</el-button>
          <el-button type="text" @click="copyUrl(scope.row,1)">{{ $t('operate.name180') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
     </div>
     <div v-if="userinfo.tenantType ===22">
      <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')">
        <el-col :span="12">
          <el-form-item :label="$t('operate.name12')" prop="versionCode">
            <el-input v-model="queryInfo.versionCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('operate.name13')" prop="keyword">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable><el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getSaleVersionList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddDialog(null,1)">{{ $t('operate.name11') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name15')" prop="versionId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name16')" prop="versionCode" sortable></el-table-column>
      <el-table-column :label="$t('operate.name27')" prop="versionDesc" sortable></el-table-column>
      <el-table-column :label="$t('operate.name17')" prop="versionType" sortable>
        <template slot-scope="scope">
            <div>{{ ['','android','ios'][scope.row.versionType] }}</div>
          </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name18')" prop="updateType" sortable>
        <template slot-scope="scope">
            <div>{{ ['', $t('operate.name30'), $t('operate.name31'), $t('operate.name32')][scope.row.updateType] }}</div>
          </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name19')" prop="status" sortable>
        <template slot-scope="scope">
           <div>{{ [$t('operate.name39'), $t('operate.name40'), $t('operate.name41')][scope.row.status] }}</div>
          </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name20')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name21')" prop="updateTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.updateTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name9')" width="168px" fixed="right">
        <template slot-scope="scope">
            <el-button type="text" @click="showUpdateStatus(scope.row)">{{ $t('operate.name23') }}</el-button>
            <el-button type="text" @click="showAddDialog(scope.row,3)">{{ $t('operate.name24') }}</el-button>
            <el-button type="text" @click="delVersion(scope.row)" style="color:#ea4646">{{ $t('operate.name25') }}</el-button>
          </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
     </div>
     <!-- 版本列表 -->
    <AppDialog size="lg" width="1100px" extra-class="el-dialog--responsive" :title="$t('operate.name10')" v-if="versionDialog" :visible.sync="versionDialog" :before-close="closeVersionList">
      <div class="search-layout">
        <el-form :model="appVersionInfo" size="medium" :inline="true">
            <el-form-item :label="$t('operate.name12')" prop="versionCode">
              <el-input v-model="appVersionInfo.versionCode" :placeholder="$t('public.name5')" clearable> </el-input>
            </el-form-item>
            <el-form-item :label="$t('operate.name13')" prop="status">
              <el-select v-model="appVersionInfo.status" :placeholder="$t('public.name1')">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="getAppVersionList2">{{ $t('public.name3') }}</el-button>
              <el-button size="medium" @click="resetAppVersionData">{{ $t('public.name4') }}</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="add-user"  v-if="buttonPerms.indexOf('versionList/new') > -1">
        <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddDialog(null,1)">{{ $t('operate.name11') }}</el-button>
      </div>
      <el-table :data="appTableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='appTableLoading'>
        <!-- <el-table-column  type="index"></el-table-column> -->
        <el-table-column :label="$t('operate.name15')" prop="versionId" sortable min-width="70"></el-table-column>
         <el-table-column :label="$t('operate.name181')" prop="versionName" sortable></el-table-column>
          <el-table-column :label="$t('operate.name16')" prop="versionCode" sortable></el-table-column>
        <el-table-column :label="$t('operate.name17')" prop="versionType" sortable>
          <template slot-scope="scope">
           <div>{{ ['','android','ios'][scope.row.versionType] }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('operate.name18')" prop="updateType" sortable>
          <template slot-scope="scope">
           <div>{{ ['', $t('operate.name30'), $t('operate.name31'), $t('operate.name32')][scope.row.updateType] }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('operate.name19')" prop="status" sortable>
          <template slot-scope="scope">
           <div>{{ [$t('operate.name39'), $t('operate.name40'), $t('operate.name41')][scope.row.status] }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('operate.name20')" prop="createTime" sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | tzDisplay }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('operate.name21')" prop="updateTime" sortable>
          <template slot-scope="scope">
            {{ scope.row.updateTime | tzDisplay }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('operate.name22')" width="180" fixed="right" v-if="buttonPerms.indexOf('versionList/operation') > -1">
          <template slot-scope="scope">
            <el-button type="text" @click="showUpdateStatus(scope.row)">{{ $t('operate.name23') }}</el-button>
            <el-button type="text" @click="showAddDialog(scope.row,3)">{{ $t('operate.name24') }}</el-button>
            <el-button type="text" @click="copyUrl(scope.row,2)">{{ $t('operate.name180') }}</el-button>
            <el-button type="text" @click="delVersion(scope.row)" style="color:#ea4646">{{ $t('operate.name25') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      background
      @size-change="appHandleSizeChange"
      @current-change="appHandleCurrentChange"
      :current-page="appVersionInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="appVersionInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="appTotal"
    >
    </el-pagination>
    </AppDialog>
    <!-- 填写版本信息 -->
    <AppDialog width="460px" :title="$t('operate.name26')" v-if="addDialog" :visible.sync="addDialog" :before-close="closeVersion">
      <el-form ref="versionFormRef" :model="versionInfo" :label-width="formLabelWidth('md3')"  :rules="versionInfoRules">
           <el-form-item prop="versionName" :label="$t('operate.name178')">
          <el-input v-model="versionInfo.versionName" :placeholder="$t('public.name5')" clearable  onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g, '')"> </el-input>
        </el-form-item>

        <el-form-item prop="versionCode" :label="$t('operate.name12')">
          <el-input v-model="versionInfo.versionCode" :placeholder="$t('public.name5')" clearable  onkeyup="value=value.replace(/[^\d]/g, '')"> </el-input>
        </el-form-item>

        <el-form-item prop="versionType" :label="$t('operate.name28')">
          <el-radio v-model="versionInfo.versionType" label="1">android</el-radio>
          <el-radio v-model="versionInfo.versionType" label="2">ios</el-radio>
        </el-form-item>

        <el-form-item prop="updateType" :label="$t('operate.name29')">
          <el-radio v-model="versionInfo.updateType" label="1">{{ $t('operate.name30') }}</el-radio>
          <el-radio v-model="versionInfo.updateType" label="2">{{ $t('operate.name31') }}</el-radio>
          <el-radio v-model="versionInfo.updateType" label="3">{{ $t('operate.name32') }}</el-radio>
        </el-form-item>
        <el-form-item prop="downloadUrl" :label="$t('operate.name33')">
          <input v-model="versionInfo.downloadUrl" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(1,e)
                }
              "
          >
            <el-button size="small" type="primary">{{ $t('operate.name34') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item prop="versionDesc" :label="$t('operate.name35')">
          <el-input type="textarea" :rows="2" :placeholder="$t('public.name5')"  v-model="versionInfo.versionDesc"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeVersion">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <!-- 修改版本状态 -->
    <AppDialog width="460px" :title="$t('operate.name36')" v-if="updateStatusDialog" :visible.sync="updateStatusDialog" :before-close="closeUpdateStatusDialog">
      <el-form ref="rolesFormRef" :model="versionStatusInfo" :label-width="formLabelWidth('sm2')">
        <el-form-item prop="version" :label="$t('operate.name37')">{{ versionStatusInfo.version }}</el-form-item>
        <el-form-item prop="status" :label="$t('operate.name38')">
          <el-radio v-model="versionStatusInfo.status" label='0'>{{ $t('operate.name39') }}</el-radio>
          <el-radio v-model="versionStatusInfo.status" label='1'>{{ $t('operate.name40') }}</el-radio>
          <el-radio v-model="versionStatusInfo.status" label='2'>{{ $t('operate.name41') }}</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleUpdateStatus">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeUpdateStatusDialog">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <!-- 添加APP信息 -->
    <AppDialog width="460px" :title="type ===1 ? $t('operate.name142') : $t('operate.name143')" v-if="appInfoDialog" :visible.sync="appInfoDialog" :before-close="handleClose">
      <el-form ref="appInfoFormRef" :model="appInfo" :label-width="formLabelWidth()"  :rules="general ? appInfoRules1 : appInfoRules">
        <el-form-item prop="tenantId" :label="$t('operate.name1')" v-if="!general">
          <el-cascader :disabled="type === 1 ? false : true" style="width:100%;" v-model="appInfo.tenantId" :placeholder="$t('public.name1')" :options="cascaderOptions" :props="{ value:'id',label:'name',children: 'child' }" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="appCode" :label="$t('operate.name127')">
          <el-input v-model="appInfo.appCode" :placeholder="$t('public.name5')"  onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g, '')"></el-input>
        </el-form-item>

        <el-form-item prop="appName" :label="$t('operate.name128')">
          <el-input v-model="appInfo.appName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="appIcon" :label="$t('operate.name144')">
              <div class="upload-layout">
                <el-upload class="avatar-uploader" action  :http-request="(e) => {handleUpLoadFile(2,e)}" :show-file-list="false">
                  <img v-if="appInfo.appIcon" :src="appInfo.appIcon" class="avatar" style="width:48px;height:48px;object-fit:cover;display:block;" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item prop="status" :label="$t('operate.name38')">
              <el-switch v-model="appInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
            </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addAppInfo" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>

    <AppDialog width="720px" :title="$t('operate.name129')" v-if="merchantListDialog" :visible.sync="merchantListDialog" :before-close="handleClose">
      <el-form  size="medium" :inline="true" :model="merchantInfo">
          <el-form-item :label="$t('operate.name1')" prop="tenantName">
            <el-input v-model="merchantInfo.tenantName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getGeneralDataList">{{ $t('operate.name80') }}</el-button>
            <el-button size="medium" @click="resetMerchantInfo">{{ $t('public.name4') }}</el-button>
            <el-button type="primary" size="medium" @click="addMerchantList">{{ $t('operate.name11') }}</el-button>
          </el-form-item>
      </el-form>
      <el-table :data="merchantTableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='merchantTableLoading'>
        <el-table-column :label="$t('manage.name68')" prop="createTime" sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | tzDisplay }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('manage.name79')" prop="tenantName" sortable></el-table-column>
        <el-table-column :label="$t('operate.name22')" width="188px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="delMerchant(scope.row)">{{ $t('operate.name25') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      background
      @size-change="merchantHandleSizeChange"
      @current-change="merchantHandleCurrentChange"
      :current-page="merchantInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="merchantInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="merchantTotal"
    >
    </el-pagination>
    </AppDialog>
    <AppDialog width="400px" :title="$t('operate.name145')" v-if="merchantDialog" :visible.sync="merchantDialog" :before-close="handleClose1">
      <el-form  size="medium" :label-width="formLabelWidth()" :inline="true" :model="addGeneralInfo" :rules="merchantInfoRules"  ref="addGeneralFormRef">
        <el-form-item prop="tenantId" :label="$t('operate.name1')">
          <el-cascader v-model="addGeneralInfo.tenantId" :placeholder="$t('public.name1')" :options="cascaderOptions" :props="{ value:'id',label:'name', children: 'child' }" clearable></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerAddGeneralInfo" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <AppDialog size="lg" width="80%" extra-class="app-config-dialog el-dialog--responsive" :title="configTitle" v-if="appConfigDialog" :visible.sync="appConfigDialog" :before-close="handleCloseConfig">
      <div class='config-content'>
        <div class='tabs'>
          <div :class="selectIndex === 0 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(0)">
            Logo
          </div>
          <!-- <div :class="selectIndex === 1 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(1)">
            {{ $t('operate.name146') }}
          </div> -->
          <div :class="selectIndex === 2 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(2)">
            {{ $t('operate.name147') }}
          </div>
          <div :class="selectIndex === 3 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(3)">
            {{ $t('operate.name148') }}
          </div>
        </div>
        <div class="right-content">
          <div class="left-img" v-if="selectIndex === 0 || selectIndex === 1">
            <img v-if="selectIndex === 0 && previewIndex === 1" src="@/assets/app_mian.jpg" alt=""  class="img"/>
            <img v-if="selectIndex === 0 && previewIndex === 2" src="@/assets/app_login.jpg" alt="" class="img" />
            <img v-if="selectIndex === 0 && appConfig.log1 && previewIndex === 1" :src="appConfig.log1" class="show-avatar2" />
            <img v-if="selectIndex === 0 && appConfig.log2 && previewIndex === 2" :src="appConfig.log2" class="show-avatar3" />
            <iframe v-if="selectIndex === 1" :src="appConfig.shopCenterUrl" class="iframe" ></iframe>
          </div>
          <div class="right-setting">
            <div v-if="selectIndex ===0">
              <div class="text1">  {{ $t('operate.name149') }}</div>
            <div class="text2">
              {{ $t('operate.name200') }}
            </div>
            <div class="upload-layout2 margin-top10">
                <el-upload class="avatar-uploader2" action  :http-request="(e) => {handleUpLoadFile(3,e)}" :show-file-list="false">
                  <img v-if="appConfig.log1" :src="appConfig.log1" class="avatar2" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="primary" @click="previewImg(1)">  {{ $t('operate.name150') }}</el-button>
              </div>
              <div class="text2">
              {{ $t('operate.name200') }}
            </div>
            <div class="upload-layout2 margin-top10">
                <el-upload class="avatar-uploader3" action  :http-request="(e) => {handleUpLoadFile(4,e)}" :show-file-list="false">
                  <img v-if="appConfig.log2" :src="appConfig.log2" class="avatar3" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="primary" @click="previewImg(2)">  {{ $t('operate.name150') }}</el-button>
              </div>
            </div>
            <div v-if="selectIndex === 1">
              <div class="text1">  {{ $t('operate.name146') }}</div>
              <div class="text2"><span>  {{ $t('operate.name151') }}</span><el-input v-model="appConfig.shopCenterUrl" :placeholder="$t('operate.name154')" class="input-shop"></el-input></div>
            </div>
            <div v-if="selectIndex === 2" class="user-notice">
              <div class="left-preview">
                 <div>
                  {{ $t('operate.name152') }}
                 </div>
                 <div v-html="appConfig.noticeToUser">
                 </div>
              </div>
              <div class="right-edit">
                <quill-editor
                class="quill-editor"
                v-model="appConfig.noticeToUser"
                ref="myQuillEditor1"
                :options="editorOption"
                />
              </div>
            </div>
            <div v-if="selectIndex === 3" class="user-notice">
              <div class="left-preview">
                 <div>
                  {{ $t('operate.name153') }}
                 </div>
                 <div v-html="appConfig.privacyPolicy">
                 </div>
              </div>
              <div class="right-edit">
                <quill-editor
                class="quill-editor"
                v-model="appConfig.privacyPolicy"
                ref="myQuillEditor2"
                :options="editorOption"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerAppConfigInfo" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleCloseConfig">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import {
  appVersionList1,
  saveAppTenant,
  appVersionList2,
  appVersionSave,
  versionUpdateStatus,
  appVersionUpdate,
  updateAppTenant,
  getAddGeneralTenantList,
  addGeneral,
  generalList,
  removeGeneral,
  sysappDelete,
  saleVersionList,
  saleVersionSave,
  saleVersionUpdate,
  saleVersionDelete,
  saleVersionUpdateStatus,
  updateAppStatus,
  getAppConfigure,
  updateAppConfigure
} from '@/api/operate.js'
import { tenantList, uploadFile } from '@/api/manage.js'
import { mapGetters } from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: {
    quillEditor,
    AppDialog
  },
  computed: {
    ...mapGetters(['userinfo']),
    statusList () {
      return [
        { value: '', label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    },
    statusOptions () {
      return [
        { value: '', label: this.$t('public.name19') },
        { value: '0', label: this.$t('manage.name14') },
        { value: '1', label: this.$t('operate.name40') },
        { value: '2', label: this.$t('operate.name41') }
      ]
    },
    rolesOptions () {
      return [
        { label: this.$t('screen.name21'), value: '1' },
        { label: this.$t('screen.name22'), value: '2' }
      ]
    },
    editorOption () {
      return {
        placeholder: this.$t('public.name5')
      }
    }
  },
  data() {
    return {
      tenantIds: [],
      type: 1,
      appInfoDialog: false,
      fileList: [],
      merchantInfoRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ]
      },
      appInfoRules: {
        appCode: [
          {
            required: true,
            message: this.$t('operate.name183'),
            trigger: 'blur'
          }
        ],
        appIcon: [
          {
            required: true,
            message: this.$t('operate.name184'),
            trigger: 'blur'
          }
        ],
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        appName: [
          {
            required: true,
            message: this.$t('operate.name185'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: this.$t('operate.name186'),
            trigger: 'blur'
          }
        ]
      },
      appInfoRules1: {
        appCode: [
          {
            required: true,
            message: this.$t('operate.name183'),
            trigger: 'blur'
          }
        ],
        appIcon: [
          {
            required: true,
            message: this.$t('operate.name184'),
            trigger: 'blur'
          }
        ],
        appName: [
          {
            required: true,
            message: this.$t('operate.name185'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: this.$t('operate.name186'),
            trigger: 'blur'
          }
        ]
      },
      versionInfo: {
        appTenantId: '',
        downloadUrl: '',
        updateType: '',
        versionCode: '',
        versionName: '',
        versionDesc: '',
        versionType: ''
      },
      merchantListDialog: false,
      merchantTableList: [],
      merchantTableLoading: false,
      merchantTotal: 0,
      merchantInfo: {
        page: 1,
        limit: 10,
        appId: '',
        tenantName: ''
      },
      merchantDialog: false,
      addGeneralInfo: {
        appTenantId: '',
        tenantId: ''
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      cascaderOptions: [],
      loading: false,
      appTableList: [],
      appTableLoading: false,
      tableLoading: false,
      appInfo: {
        appCode: '',
        appIcon: '',
        appName: '',
        status: true,
        general: false,
        tenantId: '',
        appDownloadUrl: ''
      },
      queryInfo: {
        appName: '',
        page: 1,
        limit: 10,
        tenantId: '',
        appCode: '',
        status: ''
      },
      appTotal: 0,
      options: [],
      tableList: [],
      versionDialog: false,
      // 当前打开版本弹窗的所属 App 下载路径（#/download?appCode=xxx），供版本行复制链接时拼接 versionCode 使用
      currentAppDownloadUrl: '',
      addDialog: false,
      updateStatusDialog: false,
      general: false,
      total: 0,
      selectList: [],
      versionInfoRules: {
        versionName: [
          {
            required: true,
            message: this.$t('operate.name187'),
            trigger: 'blur'
          }
        ],
        versionCode: [
          {
            required: true,
            message: this.$t('operate.name199'),
            trigger: 'blur'
          }
        ],
        // versionDesc: [
        //   {
        //     required: true,
        //     message: '请输入版本描述',
        //     trigger: 'blur'
        //   }
        // ],
        downloadUrl: [
          {
            required: true,
            message: this.$t('bike.name482'),
            trigger: 'blur'
          }
        ],
        // updateType: [
        //   {
        //     required: true,
        //     message: '请选择更新类型',
        //     trigger: 'blur'
        //   }
        // ],
        versionType: [
          {
            required: true,
            message: this.$t('operate.name186'),
            trigger: 'blur'
          }
        ]
      },
      userInfoRules: {
        account: [
          {
            required: true,
            message: this.$t('screen.name8'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('login.name3'),
            trigger: 'blur'
          }
        ]
      },
      versionStatusInfo: {
        id: '',
        version: '',
        status: '0'
      },
      userInfo: {
        account: '',
        password: '',
        name: '',
        nikeName: '',
        tel: '',
        email: '',
        status: '1'
      },
      showMsgVisible: false,
      appVersionInfo: {
        limit: 10,
        page: 1,
        status: '',
        versionCode: '',
        appTenantId: ''
      },
      showMsgallVisible: false,
      userInfoDialog: false,
      bindingRolesDialog: false,
      appConfigDialog: false,
      selectIndex: 0,
      appConfig: {
        log1: '',
        log2: '',
        shopCenterUrl: '',
        noticeToUser: '',
        privacyPolicy: '',
        id: ''
      },
      previewIndex: 1,
      buttonPerms: ''
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
    if (this.userinfo.tenantType === 22) {
      this.getSaleVersionList()
    } else {
      this.getPageList()
    }
  },
  mounted() {
  },
  methods: {
    resetQuery() {
      this.queryInfo = {
        page: 1,
        limit: 10,
        tenantId: '',
        appCode: '',
        appName: '',
        status: ''
      }
      this.tenantIds = []
      this.queryList()
    },
    getSaleVersionList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    getPageList() {
      this.queryInfo.limit = 10
      this.queryInfo.page = 1
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.userinfo.tenantType === 22) {
        if (this.queryInfo.versionCode) {
          data.versionCode = this.queryInfo.versionCode
        }
        if (this.queryInfo.status !== '') {
          data.status = this.queryInfo.status
        }
        saleVersionList(data)
          .then(res => {
            this.tableList = res.data.list
            this.total = res.data.total
            this.tableLoading = false
          })
          .catch(() => {
            this.tableList = []
            this.total = 0
            this.tableLoading = false
          })
      } else {
        if (this.queryInfo.tenantId) {
          data.tenantId = this.queryInfo.tenantId
        }
        if (this.queryInfo.appCode) {
          data.appCode = this.queryInfo.appCode
        }
        if (this.queryInfo.appName) {
          data.appName = this.queryInfo.appName
        }
        // 后端 AppTenantListRequest.status 为 Boolean：0=Enable→true，1=Disabled→false
        if (this.queryInfo.status !== '' && this.queryInfo.status != null) {
          data.status = this.queryInfo.status === 0
        }
        appVersionList1(data)
          .then(res => {
            this.tableList = res.data.list
            this.total = res.data.total
            this.tableLoading = false
          })
          .catch(() => {
            this.tableList = []
            this.total = 0
            this.tableLoading = false
          })
      }
    },
    changeSwitch(row, e) {
      this.tableLoading = true
      updateAppStatus({ id: row.id })
        .then(res => {
          this.getPageList()
        })
        .catch(() => {
        })
    },
    handleAdd(general) {
      this.general = general
      this.appInfo.general = general
      this.type = 1
      this.appInfoDialog = true
      if (!this.general) {
        this.getAddGeneralTenantListData()
      }
    },
    handleEdit(row) {
      this.type = 2
      this.general = row.general || false
      this.appInfo.id = row.id
      this.appInfo.appCode = row.appCode
      this.appInfo.appIcon = row.appIcon
      this.appInfo.appName = row.appName
      this.appInfo.status = row.status
      this.appInfo.general = row.general
      this.appInfo.tenantId = [row.parentTenantId, row.tenantId]
      this.appInfoDialog = true
      getAddGeneralTenantList()
        .then((res) => {
          res.data.map((item) => {
            item.child.map((items) => {
              items.child = undefined
            })
          })
          this.cascaderOptions = res.data
          const obj = {}
          obj.id = row.parentTenantId
          obj.name = row.parentTenantName
          obj.child = [
            {
              id: row.tenantId,
              name: row.tenantName,
              child: undefined
            }
          ]
          this.cascaderOptions.push(obj)
        })
        .catch(() => {})
    },
    addMerchantList() {
      this.merchantDialog = true
      this.getAddGeneralTenantListData()
    },
    handleClose1() {
      this.merchantDialog = false
    },
    getAddGeneralTenantListData() {
      getAddGeneralTenantList()
        .then((res) => {
          res.data.map((item) => {
            item.child.map((items) => {
              items.child = undefined
            })
          })
          this.cascaderOptions = res.data
        })
        .catch(() => {})
    },
    handleClose() {
      this.appInfo = {
        appCode: '',
        appIcon: '',
        appName: '',
        status: true,
        tenantId: ''
      }
      this.appInfoDialog = false
      this.merchantListDialog = false
      this.merchantInfo = {
        page: 1,
        limit: 10,
        keyword: ''
      }
    },

    closeVersion() {
      this.addDialog = false
      this.fileList = []
      this.versionInfo = {
        appTenantId: this.versionInfo.appTenantId,
        downloadUrl: '',
        updateType: '',
        versionCode: '',
        versionName: '',
        versionDesc: '',
        versionType: ''
      }
    },
    closeVersionList() {
      this.versionDialog = false
    },
    showVersionDialog(row) {
      this.appTableLoading = true
      this.appVersionInfo.appTenantId = row.id
      this.versionInfo.appTenantId = row.id
      // 记录所属 App 的下载路径，版本行复制链接时需要用它拼接 versionCode
      this.currentAppDownloadUrl = row.appDownloadUrl
      this.queryAppVersionList()
      this.versionDialog = true
    },
    resetAppVersionData() {
      this.appVersionInfo = {
        limit: 10,
        page: 1,
        status: '',
        versionCode: '',
        appTenantId: this.appVersionInfo.appTenantId
      }
      this.queryAppVersionList()
    },
    queryAppVersionList() {
      this.appTableLoading = true
      const data = {
        limit: this.appVersionInfo.limit,
        page: this.appVersionInfo.page,
        appId: this.appVersionInfo.appTenantId
      }
      if (this.appVersionInfo.versionCode) {
        data.versionCode = this.appVersionInfo.versionCode
      }
      if (this.appVersionInfo.status !== 2) {
        data.status = this.appVersionInfo.status
      }
      appVersionList2(data)
        .then((res) => {
          this.appTableList = res.data.list
          this.appTotal = res.data.total
          this.appTableLoading = false
        })
        .catch(() => {
          this.appTableList = []
          this.appTotal = 0
          this.appTableLoading = false
        })
    },
    getAppVersionList2() {
      this.appVersionInfo.page = 1
      this.appVersionInfo.limit = 10
      this.queryAppVersionList()
    },
    copyUrl(row, type) {
      // type=1：App 行，下载路径取自 App 本身；type=2：版本行，下载路径取自所属 App（弹窗打开时已缓存）
      const appDownloadUrl = type === 1 ? row.appDownloadUrl : this.currentAppDownloadUrl
      if (!appDownloadUrl) {
        this.$message({
          message: this.$t('operate.name189'),
          type: 'error'
        })
        return
      }
      let url = this.baseUrl + appDownloadUrl
      if (type !== 1) {
        url = url + '&versionCode=' + row.versionCode
      }
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$message({
            message: this.$t('operate.name188'),
            type: 'success'
          })
        })
        .catch(() => {
          this.$message({
            message: this.$t('operate.name189'),
            type: 'error'
          })
        })
    },
    showAddDialog(row, type) {
      this.type = type
      if (this.type === 3) {
        if (row.file) {
          this.fileList = [{ name: row.file.fileName, url: row.file.url }]
        } else {
          this.fileList = []
        }
        this.versionInfo.downloadUrl = row.downloadUrl
        this.versionInfo.updateType = row.updateType + ''
        this.versionInfo.versionCode = row.versionCode
        this.versionInfo.versionName = row.versionName
        this.versionInfo.versionDesc = row.versionDesc
        this.versionInfo.versionType = row.versionType + ''
        this.versionInfo.versionId = row.versionId
      } else {
        if (row !== null) {
          this.versionInfo.appTenantId = row.id
        }
      }
      this.addDialog = true
    },
    showUpdateStatus(row) {
      this.versionStatusInfo.id = row.versionId
      this.versionStatusInfo.version = row.versionCode
      this.versionStatusInfo.status = row.status + '' || '0'
      this.updateStatusDialog = true
    },
    addUser() {
      this.userInfoDialog = true
    },
    closeUpdateStatusDialog() {
      this.updateStatusDialog = false
    },
    handleUpdateStatus() {
      const data = {
        id: this.versionStatusInfo.id,
        status: parseInt(this.versionStatusInfo.status)
      }
      if (this.userinfo.tenantType === 22) {
        saleVersionUpdateStatus(data).then(res => {
          if (res.code === 200) {
            this.closeUpdateStatusDialog()
            this.queryList()
          }
        }).catch(res => {})
      } else {
        versionUpdateStatus(data).then(res => {
          if (res.code === 200) {
            this.closeUpdateStatusDialog()
            this.queryAppVersionList()
          }
        }).catch(res => {})
      }
    },
    handleRemove(file, fileList) {
      this.versionInfo.downloadUrl = ''
      this.fileList = []
    },
    handleUpLoadFile(type, param) {
      this.fileList = []
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            if (type === 1) {
              this.versionInfo.downloadUrl = res.data.fileId
              this.fileList = [{ name: res.data.fileName, url: res.data.fileUrl }]
            } else if (type === 2) {
              this.appInfo.appIcon = res.data.fileUrl
            } else if (type === 3) {
              this.appConfig.log1 = res.data.fileUrl
              this.previewIndex = 1
            } else if (type === 4) {
              this.appConfig.log2 = res.data.fileUrl
              this.previewIndex = 2
            }
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          this.fileList = []
          loading.close()
        })
    },
    handlerAddGeneralInfo() {
      this.$refs.addGeneralFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        this.addGeneralInfo.tenantId = this.addGeneralInfo.tenantId[1]
        addGeneral(this.addGeneralInfo)
          .then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.handleClose1()
              this.getGeneralList()
            }
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    addAppInfo() {
      this.$refs.appInfoFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        this.appInfo.tenantId = this.appInfo.tenantId[1]
        this.appInfo.appCode = this.appInfo.appCode.trim()
        this.appInfo.appName = this.appInfo.appName.trim()
        this.appInfo.appDownloadUrl = '#/download?appCode=' + this.appInfo.appCode.trim()
        if (this.type === 1) {
          saveAppTenant(this.appInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.handleClose()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          var appInfo = {}
          if (this.appInfo.general) {
            this.appInfo.tenantId = null
            appInfo = {
              appCode: this.appInfo.appCode,
              appIcon: this.appInfo.appIcon,
              appName: this.appInfo.appName,
              general: this.appInfo.general,
              id: this.appInfo.id,
              status: this.appInfo.status
            }
          } else {
            appInfo = this.appInfo
          }
          updateAppTenant(appInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.handleClose()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    submitForm() {
      this.$refs.versionFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        if (this.type === 1) {
          if (this.userinfo.tenantType === 22) {
            saleVersionSave(this.versionInfo)
              .then((res) => {
                this.loading = false
                if (res.code === 200) {
                  this.closeVersion()
                  this.queryList()
                }
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            appVersionSave(this.versionInfo)
              .then((res) => {
                this.loading = false
                if (res.code === 200) {
                  this.closeVersion()
                  this.queryAppVersionList()
                  this.queryList()
                }
              })
              .catch(() => {
                this.loading = false
              })
          }
        } else {
          if (this.userinfo.tenantType === 22) {
            saleVersionUpdate(this.versionInfo).then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.closeVersion()
                this.queryList()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
            appVersionUpdate(this.versionInfo).then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.closeVersion()
                this.queryAppVersionList()
              }
            }).catch(() => {
              this.loading = false
            })
          }
        }
      })
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    showMerchantDialog(row) {
      this.addGeneralInfo.appTenantId = row.id
      this.merchantInfo.appId = row.id
      this.merchantListDialog = true
      this.queryMerchantList()
    },
    resetMerchantInfo() {
      this.merchantInfo.tenantName = ''
      this.merchantInfo.page = 1
      this.merchantInfo.limit = 10
      this.queryMerchantList()
    },
    getGeneralDataList() {
      this.merchantInfo.page = 1
      this.merchantInfo.limit = 10
      this.queryMerchantList()
    },
    queryMerchantList() {
      this.merchantTableLoading = true
      if (this.merchantInfo.tenantName) {
        this.merchantInfo.tenantName = this.merchantInfo.tenantName.trim()
      }
      generalList(this.merchantInfo)
        .then((res) => {
          this.merchantTableList = res.data.list
          this.merchantTotal = res.data.total
          this.merchantTableLoading = false
        })
        .catch(() => {
          this.merchantTableList = []
          this.merchantTotal = 0
          this.merchantTableLoading = false
        })
    },
    getGeneralList() {
      this.queryMerchantList()
    },
    delMerchant(row) {
      this.$confirm(this.$t('public.name40'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeGeneral({ appVersionId: row.id }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('public.name30')
              })
              this.getGeneralList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    delVersion(row) {
      this.$confirm(this.$t('public.name40'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          if (this.userinfo.tenantType === 22) {
            saleVersionDelete({ id: row.versionId })
              .then((res) => {
                if (res.code === 200) {
                  this.$message({
                    type: 'success',
                    message: this.$t('public.name30')
                  })
                  this.queryList()
                  this.queryAppVersionList()
                }
              })
              .catch(() => {})
          } else {
            sysappDelete({ id: row.versionId })
              .then((res) => {
                if (res.code === 200) {
                  this.$message({
                    type: 'success',
                    message: this.$t('public.name30')
                  })
                  this.queryAppVersionList()
                  this.queryList()
                }
              })
              .catch(() => {})
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      // this.getMerchantUserList()
    },
    showAppConfigurationDialog(row) {
      this.appConfigDialog = true
      this.configTitle = row.appName + '(' + row.appCode + ')' + this.$t('operate.name203')
      getAppConfigure({ appCode: row.appCode }).then((res) => {
        if (res.code === 200) {
          this.appConfig.log1 = res.data.log1
          this.appConfig.log2 = res.data.log2
          this.appConfig.noticeToUser = res.data.noticeToUser
          this.appConfig.privacyPolicy = res.data.privacyPolicy
          this.appConfig.shopCenterUrl = res.data.shopCenterUrl
          this.appConfig.id = row.id
        }
      }).catch(() => {})
    },
    clickTbas(index) {
      this.selectIndex = index
    },
    previewImg(index) {
      this.previewIndex = index
    },
    handleCloseConfig() {
      this.appConfigDialog = false
    },
    handlerAppConfigInfo() {
      updateAppConfigure(this.appConfig).then((res) => {
        if (res.code === 200) {
          this.$message({ type: 'success', message: this.$t('operate.name190') })
        }
      }).catch(() => {})
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    },
    appHandleSizeChange(newSize) {
      this.appVersionInfo.limit = newSize
      this.queryAppVersionList()
    },
    appHandleCurrentChange(newPage) {
      this.appVersionInfo.page = newPage
      this.queryAppVersionList()
    },
    merchantHandleSizeChange(newSize) {
      this.merchantInfo.limit = newSize
      this.queryMerchantList()
    },
    merchantHandleCurrentChange(newPage) {
      this.merchantInfo.page = newPage
      this.queryMerchantList()
    }
  }
}
</script>
<style lang="scss" scoped>
// Page shell only — AppDialog uses append-to-body, so dialog styles must NOT nest here.
.overviewapplisting-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}

// Dialog content is teleported to <body>; keep selectors unscoped-from-container.
.app-config-dialog {
  position: fixed;
  top: -10vh !important;
}

.config-content {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  width: 100%;
  height: calc(100vh - 270px);

  .tabs {
    display: flex;
    width: 202px;
    flex-direction: column;

    .tab-select {
      width: 200px;
      height: 50px;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(245, 245, 245);
      border-left: 4px solid #409eff;
      cursor: pointer;
    }

    .tab-unselect {
      width: 202px;
      height: 50px;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 1px solid rgb(245, 245, 245);
    }
  }

  // Must fit left phone preview (375px) + settings; was width:375px and crushed Preview.
  .right-content {
    flex: 1;
    min-width: 0;
    width: calc(100% - 202px);
    display: flex;
    margin-left: 50px;
    height: calc(100vh - 280px);
    flex-direction: row;
    overflow: hidden;

    .left-img {
      flex: 0 0 375px;
      width: 375px;
      height: auto;
      max-height: 100%;
      position: relative;
      overflow: hidden;

      > .img {
        width: 100%;
        height: auto;
        display: block;
      }

      iframe {
        width: 100%;
        height: calc(100vh - 280px);
      }
    }

    .right-setting {
      flex: 1;
      min-width: 0;
      width: calc(100% - 405px);
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      overflow: auto;

      .text1 {
        color: #000;
        font-size: 18px;
        font-weight: 600;
      }

      .text2 {
        width: 100%;
        font-size: 16px;
        margin-top: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          width: 120px;
        }
      }

      .input-shop {
        width: 400px;
        max-width: 100%;
      }
    }
  }
}

.margin-top10 {
  margin-top: 10px;
}

.upload-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 48px;

  .avatar {
    width: 48px;
    height: 48px;
  }

  > :last-child {
    margin-left: 10px;
    font-size: 12px;
    color: #555;
    line-height: 16.8px;
  }

  ::v-deep .avatar-uploader {
    width: 48px;
    height: 48px;
    overflow: hidden;
  }

  ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 48px !important;
    height: 48px !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.upload-layout2 {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 20px;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 48px;
  height: 48px;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .avatar-uploader2 {
  border: 1px dashed #d9d9d9 !important;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 100px;
  overflow: hidden;
  margin-right: 20px;

  .el-upload {
    width: 200px !important;
    height: 100px !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  img {
    width: 200px !important;
    height: 100px !important;
    object-fit: cover;
    display: block;
  }
}

::v-deep .avatar-uploader3 {
  border: 1px dashed #d9d9d9 !important;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 50px;
  overflow: hidden;
  margin-right: 20px;

  .el-upload {
    width: 200px !important;
    height: 50px !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  img {
    width: 200px !important;
    height: 50px !important;
    object-fit: cover;
    display: block;
  }
}

.avatar2 {
  width: 200px !important;
  height: 100px !important;
  object-fit: cover;
  display: block;
}

.avatar3 {
  width: 200px !important;
  height: 50px !important;
  object-fit: cover;
  display: block;
}

.show-avatar2 {
  width: 200px !important;
  height: 100px !important;
  position: absolute;
  left: 50%;
  top: 160px;
  object-fit: cover;
  transform: translate(-50%, 0);
  z-index: 2;
}

.show-avatar3 {
  width: 200px !important;
  height: 50px !important;
  position: absolute;
  left: 50%;
  top: 110px;
  object-fit: cover;
  transform: translate(-50%, 0);
  z-index: 2;
}

.user-notice {
  display: flex;
  width: 100%;
  justify-content: space-between;

  .left-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    height: calc(100vh - 305px);
    border-radius: 10px;
    overflow: auto;
    padding: 15px;
    border: 2px solid rgb(245, 245, 245);
  }

  .right-edit {
    width: calc(100% - 375px);
    margin-left: 30px;

    .quill-editor {
      width: 720px;
      height: calc(100vh - 340px);
    }
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
</style>
